var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("언론보도")])]), _c('router-view', {
    attrs: {
      "name": "board",
      "code": "press",
      "skin": "gallery",
      "hide-write-button": ""
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }